import Intents from '@ux/intents';
const intents = new Intents();

export function getIntents(intent) {
  if (!intent) return null;
  if (typeof intent === 'string' && intent[0] === '#') return intent;

  const [theme, value] = intent.split('.');

  return intents.ux[theme]?.[value] || null;
}
